import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55b1429e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMousedown"]

import { ref, withDefaults, watch, onMounted } from 'vue';
import * as IDESideBarContent from './IDESideBarContent.vue';

interface StartResizeState {
	cursorPositionX: number;
	sideBarContentWidth: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContentResizer',
  props: {
    IDESideBarContentInstance: { default() {
		return null;
	} },
    shown: { type: Boolean, default() {
		return true;
	} }
  },
  setup(__props: any) {

const props = __props as { IDESideBarContentInstance: InstanceType<typeof IDESideBarContent.default>|null, shown: boolean }




const isResizing = ref(false);
let startResizeState:StartResizeState|null = null;

function startResize(e:MouseEvent) {
	if (!props.IDESideBarContentInstance) {
		return;
	}

	// poznamenat si pocatecni stav, kdy zacla zmena velikosti
	// pozici kurzoru a sirku obsahoveho elementu
	startResizeState = {
		cursorPositionX: e.clientX,
		sideBarContentWidth: props.IDESideBarContentInstance.getWidth(),
	}
	isResizing.value = true;
}

onMounted(() => {
	window.addEventListener("mousemove", (e:MouseEvent) => {
		if (!props.IDESideBarContentInstance) {
			return;
		}

		if (isResizing.value && startResizeState != null) {
			const diff = e.clientX - startResizeState.cursorPositionX;
			const newSideBarContentWidth = startResizeState.sideBarContentWidth + diff;
			//console.log({newSideBarContentWidth});
			props.IDESideBarContentInstance.setWidth(newSideBarContentWidth);
		}
	});
	window.addEventListener("mouseup", (e:MouseEvent) => {
		isResizing.value = false;
	});
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["IDESideBarContentResizer", {shown: __props.shown, isResizing: isResizing.value}]),
    onMousedown: _withModifiers(startResize, ["prevent"])
  }, null, 42, _hoisted_1))
}
}

})